import { uiLogger } from "@nx/ui-utils"

// @ts-ignore
window.logger = uiLogger

export { default } from "./lib/ToolViewer"
export { default as toolViewerStore } from "./lib/store"
